module.exports = __webpack_public_path__ + "img/johan_cv_3.ac55bb97.jpg";